module.exports = __webpack_public_path__ + "img/606e347.jpg";